import { pathJoin } from '../../../../routing/utils';

// Pure path map — no component imports. `:conversationId` is the thread detail
// view; `case/:caseId` is a citizen case (Sager) detail; the section landing
// (`exact`) is the unified Beskeder inbox.
export const createRoutesMap = (prefix: string) => ({
  ':conversationId': (conversationId = ':conversationId') =>
    pathJoin(prefix)(conversationId).chain,
  'case/:caseId': (caseId = ':caseId') =>
    pathJoin(prefix)('case')(caseId).chain,
});
